import React, { ReactElement } from 'react';
import { Badge } from 'antd';

import useStaticContent from 'shared/hooks/useStaticContent';
import { isListingStatusIdHidden } from 'utils/listing/checkers';

import './ListingStatusBadge.scss';

interface Props {
  listingStatusId: number;
  listingStatusReason?: string;
}

function ListingStatusBadge(props: Props): ReactElement {
  const { listingStatusId, listingStatusReason } = props;
  const listingStatuses = useStaticContent('listingStatuses');
  const listingStatus = listingStatuses?.find(
    (status: { id: number }) => status.id === listingStatusId
  );
  const styleClassModifier = `ListingStatusBadge--${listingStatus?.name.toLowerCase()}`;
  const badgeText =
    isListingStatusIdHidden(listingStatusId) && listingStatusReason
      ? `${listingStatus?.name} - ${listingStatusReason}`
      : listingStatus?.name;

  return (
    <Badge
      className={`ListingStatusBadge ${styleClassModifier}`}
      status="default"
      text={badgeText}
    />
  );
}

export default ListingStatusBadge;
